import axios from "../../axios";

const URL = "/programs";

// Get programs in pretesting phase for the current pentester
export const getPretestingPrograms = async () => {
  const response = await axios.get(`${URL}/pretesting`);
  return response.data;
};

// Mark a program as ready for reporting phase
export const markProgramReady = async (programId: number) => {
  const response = await axios.post(`${URL}/${programId}/mark-ready`);
  return response.data;
};
